export const whitelabelConfig = {
  short: 'limango',
  assetUrl: '/whitelabel/limango/',
  storeName: 'limango Online Store',
  company: 'we-are.travel GmbH',
  supportMail: 'info@we-are.travel',
  supportPhone: '+43 732 60 05 36',
  analyticsId: 'G-806JHD9VE1', //ga4
  analyticsId_ua: 'UA-156259931-9', //old ua
  analyticsType: 'gtag', //should be 'gtag', 'ua' or 'both'
  iconUrl: '/img/icons/limango/',
  logoHeader:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/limango/limango-logo.svg',
  logoFooter:
    'https://assets.urlaubsgutschein.kaufen/whitelabel/limango/limango-logo-white.svg',
  // logoHeader: () => require('@/assets/limango-logo.svg'),
  // logoFooter: () => require('@/assets/limango-logo-white.svg'),
  isStandalone: true,
  showHeader: true,
  showHeaderLogo: false,
  showFooterLogo: false,
  showTotalPrice: false,
  showReduction: true,
  heroTitle:
    '<span class="has-background-primary hero-title-accent">Ihr Kurzurlaub</span> <span class="hero-title-subaccent">clever & günstig</span>',
  hasHeroSubtitle: false,
  heroSubtitle: 'Clever & einfach reisen mit Urlaubsgutscheinen!',
  hasHeroAddition: false,
  heroAdditionText: 'Gutscheine sind 3 Jahre gültig&nbsp;',
  //heroInfoText: 'Sparen Sie bis zu 70% für Ihren Kurzurlaub.',
  heroBadge: {
    file: 'badge-70p.svg',
  },
  heroHomeOnly: true,
  heroPoweredBy: true,
  hasCookieConsent: true,
  hasOfferCta: true,
  hasLargeHotelSlider: false,
  fixedNavbar: true,
  campaignsEnabled: true,
  hasNewsletterOptin: false,
  heroImageResolution: {
    xl: {width: 2560, height: 500, crop: 'smart'},
    l: {width: 1200, height: 500, crop: 'smart'},
    m: {width: 1024, height: 500, crop: 'smart'},
    s: {width: 960, height: 300, crop: 'east'},
    xs: {width: 700, height: 300, crop: 'centre'},
  },
  homepage: {
    advantages: 'small',
  },
  showPromoNotification: false,
  fbPixelEnabled: false,
  fbPixelId: '0',
  // activeOffersOnly: true,
  styleOverride: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackPreload: true */ '@/styles/styles-limango.scss'
    ),
}
